import React from 'react';
import CustomSection from '../../custom-general/custom-section';
import Conditional from '../../../common/conditional';
import EmptyPID from './empty';
import Image from '../../../blocks/report-image/image';

import { getOptimizedImageURL, matchPhrases } from '../../../../utils/utilities';
import { PDFImageProps } from '../../../../utils/models';

import classNames from './style.module.scss';
import config from '../../../../utils/config';
interface PIDProps {
	label?: string;
	identifier?: string;
	pidNumber?: string;
	pidImages: PDFImageProps[];
	hasPID: string;
	sectionTitle: string;
	sectionSubtitle?: string;
}

const PID: React.FC<PIDProps> = ({ label = 'P&ID Number', hasPID, identifier, pidNumber, pidImages, sectionSubtitle, sectionTitle = "P&ID" }) => {
	return (
		<>
			<Conditional isVisible={matchPhrases(hasPID, 'yes')}>
				{pidImages.map((pidImage) => (
					<CustomSection key={pidImage.refNo} sectionTitle={sectionTitle} sectionSubtitle={sectionSubtitle} identifier={identifier}>
						<div className={classNames.anomalyLocationHeader}>
							{label}: <span className="mx-2">{pidNumber ? pidNumber : pidImage.caption}</span>
						</div>
						<div className={classNames.anomalyLocation}>
							<Conditional isVisible={config.requireImagesToPublish}>
								<Image src={getOptimizedImageURL(pidImage.src)} alt={pidImage.caption}/>
							</Conditional>
						</div>
					</CustomSection>
				))}
			</Conditional>

			<Conditional isVisible={matchPhrases(hasPID, 'no')}>
				<EmptyPID />
			</Conditional>
		</>
	);
};

export default PID;
